"use client";

import { LocationContext } from "@/components/framework/locationswitcher/locationReducer";
import getRegionTheaters from "@/lib/client/getRegionTheaters";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { use, useEffect } from "react";


//#region [Component]
export default function DeepLinkLocationOverride() {
    const locationState = use(LocationContext);
    const pathName = usePathname()

    const { data, isFetching } = useQuery({
        queryFn: getRegionTheaters,
        queryKey: ["theaters"]
    });

    //useWhatChanged([locationState.selected, data, isFetching, locationState.dispatcher]);

    useEffect(() => {
        console.group("DeepLinkLocationOverride");
        if (!isFetching && data) {
            console.debug("Data fetched");
            console.debug("Locationstate replaced?", locationState.replaced);
            // step 1. If the initial url has a hash, and it does not match the selected, override the selected
            if (window?.location?.hash && !locationState.replaced) {
                console.debug("Input hash present", window.location.hash);
                const inputHashLocations = window.location.hash.substring(1).split("_").map(h => decodeURIComponent(h).toLowerCase().trim());
                console.debug("Input hash locations", inputHashLocations);
                const theaters = data.flatMap(rt => rt.theaters);
                const selected = theaters.filter(th => th.location && inputHashLocations.includes(th.location.toLowerCase().trim()));
                console.debug("Selected from hash", selected);
                if (selected.length > 0 && !locationState.replaced) {
                    console.debug("Overrinding selected", selected);
                    locationState.dispatcher({ type: "replace", value: selected, save: true, replaced: true });
                }
            } else if (locationState.selected.length > 0) {
                // step 2: the user changes location or hash has nopt been set
                const newHash = locationState.selected.map(s => s.location!.trim().toLowerCase()).join("_");
                console.debug("HASH DIFF", "#" + newHash, window?.location?.hash)
                if (window?.location) {
                    if (("#" + newHash) !== window.location.hash) {
                        console.debug("SETTING HASH", newHash);
                        window.location.hash = newHash;
                    }
                }

            }
        }
        console.groupEnd();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationState.selected, data, isFetching, locationState.dispatcher, locationState.replaced, pathName]);


    return null;
}
//#endregion